<template>
    <div
        ref="searchDropdown"
        :class="{ searchDropdown: true, 'searchDropdown--fit': element === SORT_FILTER }"
        @keydown.enter.space="selectValue(options[selectedResult])"
        @focus="open = true"
        @keydown.esc.prevent="open = false"
        @keydown.down.prevent="selectDown"
        @keydown.up.prevent="selectUp"
        @blur="open = false">
        <button
            :disabled="disabled"
            class="searchDropdown__buttonArea selected"
            :class="{ 'searchDropdown__buttonArea--bordered' : bordered, open, 'selected--disabled' : disabled, 'selected--bordered' : bordered }"
            @click.prevent="toggleOpen">
            <span
                v-if="element === SORT_FILTER"
                class="inlineDropdown__label padding-right-5">
                {{ trans('FORM_SEARCH_SORT_METHOD') }}:
            </span>
            <span :class="{ 'selected__label': true, 'selected__label--bold': element === SORT_FILTER }">
                {{ currentValue?.name ?? currentValue?.label }}
            </span>
            <svg
                height="16px"
                width="16px"
                :class="{ 'selected__icon' : true, 'selected__icon--open': open }"
                aria-hidden="true">
                <use href="#iconChevronDownBold" />
            </svg>
        </button>
        <div
            id="customDropDownOptions"
            ref="customDropDownOptions"
            aria-labelledby="searchCustomDropdown"
            aria-controls="searchDropDownOptions"
            :aria-expanded="open"
            class="searchDropdown items items--shadow"
            :class="{ selectHide: !open, 'items--active' : open, 'items--bordered': bordered, 'items--leftAligned': element !== SORT_FILTER }">
            <button
                v-for="option of options"
                :id="`${ element }option--${ option.value }`"
                :key="option.name ?? option.label"
                ref="searchDropDownOptionValue"
                type="button"
                :data-gtm="`${ element }option--${ option.value }`"
                :disabled="option.value < DISABLE_DROPDOWN"
                class="searchDropdown__button text-ellipsis"
                :aria-selected="isSelected(option)"
                @click.prevent="selectValue(option)"
                @keydown.enter.prevent="selectValue(option)">
                <span
                    v-if="type === RADIO_TYPE"
                    class="searchRadioContainer text-ellipsis">
                    <input
                        type="radio"
                        class="searchRadioContainer__input"
                        :checked="currentValue === option"
                        :name="`${ element }option--${ option.value }`"
                        @keyup.enter="selectValue(option)"
                        @click="selectValue(option)">
                    <span class="outerCircle"></span>
                    <span class="searchRadio__option">{{ option.name ?? option.label }}</span>
                </span>
                <span
                    v-else
                    class="margin-left-5 margin-right-5">
                    <label class="searchCheckbox">
                        <input
                            type="checkbox"
                            :checked="currentValue === option">
                        <span class="searchCheckbox__border">
                            <span class="searchCheckbox__icon"></span>
                        </span>
                        {{ option.name ?? option.label }}
                    </label>
                </span>
            </button>
        </div>
    </div>
</template>
<script>
    import Translator from 'tools/trans';
    const SORT_FILTER = 'sort';
    const RADIO_TYPE = 'radio';
    const CHECKBOX_TYPE = 'checkbox';
    const DISABLE_DROPDOWN = -1;
    const HIDE_SVG = -2;
    export default {
        name: 'SearchDropdown',
        props: {
            options: {
                type: Array,
                required: true,
            },
            default: {
                type: Object,
                default: () => undefined,
            },
            value: {
                type: String,
                default: '',
            },
            element: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: RADIO_TYPE,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            bordered: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                open: false,
                dropValue: this.value ?? this.default.value ?? '',
                selectedResult: 0,
                SORT_FILTER: SORT_FILTER,
                DISABLE_DROPDOWN: DISABLE_DROPDOWN,
                HIDE_SVG: HIDE_SVG,
                RADIO_TYPE: RADIO_TYPE,
                CHECKBOX_TYPE: CHECKBOX_TYPE,
            };
        },
        computed: {
            currentValue() {
                return this.options.find(option => option.value === this.dropValue);
            },
        },
        watch: {
            disabled(val) {
                if (val === true) {
                    this.open = false;
                }
            },
        },
        methods: {
            trans: Translator.trans,
            selectValue(option) {
                this.dropValue = option.value;
                this.open = false;
                this.$emit('changeValue', option.value);
            },
            async selectUp() {
                this.open = true;
                if (this.selectedResult <= 0) {
                    this.selectedResult = this.options.length - 1;
                    this.dropValue = this.options[this.options.length - 1].value;

                } else {
                    this.selectedResult = this.selectedResult - 1;
                    this.dropValue = this.options[this.selectedResult].value;
                }
                document.getElementById(`${ this.element }option--${ this.dropValue }`).focus();
                this.$refs['customDropDownOptions'].scrollBy({
                    top: -30,
                    behavior: 'smooth',
                });
                if (this.selectedResult === this.options.length - 1) {
                    this.$refs['customDropDownOptions'].scroll({
                        top: 1000,
                        behavior: 'smooth',
                    });
                }
            },
            async selectDown() {
                this.open = true;
                if (this.selectedResult >= this.options.length -1) {
                    this.selectedResult = 0;
                    this.dropValue = this.options[0].value;
                } else {
                    this.selectedResult = this.selectedResult + 1;
                    this.dropValue = this.options[this.selectedResult].value;
                }
                document.getElementById(`${ this.element }option--${ this.dropValue }`).focus();

                this.$refs['customDropDownOptions'].scrollBy({
                    top: 30,
                    behavior: 'smooth',
                });
                if (this.selectedResult === 0) {
                    this.$refs['customDropDownOptions'].scroll({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
            },
            isSelected(option) {
                return this.currentValue === option;
            },
            toggleOpen() {
                this.open = !this.open;
                if (this.open) {
                    document.addEventListener('click', this.closeDropdownOnClickOutside);

                } else {
                    document.removeEventListener('click', this.closeDropdownOnClickOutside);
                }
            },
            closeDropdownOnClickOutside(event) {
                // Check if the clicked element is not within the dropdown
                if (!this.$refs.searchDropdown?.contains(event.target)) {
                    // Close the dropdown
                    this.open = false;
                }
            },
        },
    };
</script>
